import { SkeletonLoader } from '@/components/SkeletonLoader';

import CoworkingProductSkeleton from './CoworkingProductSkeleton';

export default function CoworkingProductsSkeleton() {
  return (
    <div className="flex flex-col gap-5">
      <SkeletonLoader className="w-full h-10 max-lg:mb-2" />
      <ul className="grid mt-5 min-[1300px]:grid-cols-2 gap-x-20 gap-y-16 lg:gap-y-5">
        <li>
          <CoworkingProductSkeleton />
        </li>
        <li>
          <CoworkingProductSkeleton />
        </li>
      </ul>
    </div>
  );
}
